import React from 'react'
import { Card } from 'plume-ui'
import { CardInnerTitle } from '../../atoms/CardInnerTitle'
import { Table, TableHeading, TableCell } from '../../atoms/Table'
import { CurrentInvestment } from '../../../types'
import { A } from '../../atoms/A'
import { roundDetailUrl } from '@/lib/url'
import { formatWithComma } from '@/lib/number'
import { EmptyCard } from '../../common/EmptyCard'
import { FormattedDate } from '../../atoms/FormattedDate'

type Props = {
  list: CurrentInvestment[]
  investorShortName: string
  className?: string
}

export const CurrentInvestments: React.FC<Props> = (props) => {
  return (
    <Card className={props.className}>
      <CardInnerTitle title="ラウンド明細（投資先）一覧" />
      {props.list.length > 0 ? (
        <Table className="startup-investment-table">
          <thead>
            <tr>
              <TableHeading>明細行</TableHeading>
              <TableHeading>年月日</TableHeading>
              <TableHeading>スタートアップ</TableHeading>
              <TableHeading>ラウンド</TableHeading>
              <TableHeading>内容</TableHeading>
              <TableHeading>ファンド名</TableHeading>
              <TableHeading sub="円">株価</TableHeading>
              <TableHeading>株数</TableHeading>
              <TableHeading sub="千円">投資額</TableHeading>
              <TableHeading>備考</TableHeading>
            </tr>
          </thead>
          <tbody>
            {props.list.map((investment, i) => (
              <tr key={i}>
                <TableCell>
                  <A
                    href={roundDetailUrl(
                      investment.company.shortname,
                      investment.shortname
                    )}
                    decoration="none"
                    target="_blank"
                  >
                    {investment.shortname}
                  </A>
                </TableCell>
                <TableCell>
                  <FormattedDate>{investment.date}</FormattedDate>
                </TableCell>
                <TableCell>
                  <A
                    href={investment.company.path}
                    decoration="none"
                    target="_blank"
                  >
                    {investment.company.name}
                  </A>
                </TableCell>
                <TableCell>{investment.round}</TableCell>
                <TableCell>{investment.detail}</TableCell>
                <TableCell className="fund-name">
                  <A
                    href={`/investors/${props.investorShortName}/funds/${investment.fund.shortname}`}
                    decoration="none"
                    target="_blank"
                  >
                    {investment.fund.name}
                  </A>
                </TableCell>
                <TableCell>
                  {investment.price &&
                    formatWithComma(investment.price, { decimalPlace: 1 })}
                </TableCell>
                <TableCell>
                  {investment.numOfStocks &&
                    formatWithComma(investment.numOfStocks, {
                      decimalPlace: 2,
                    })}
                </TableCell>
                <TableCell>
                  {investment.amount && formatWithComma(investment.amount)}
                </TableCell>
                <TableCell>{investment.remark}</TableCell>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <EmptyCard />
      )}
    </Card>
  )
}
